(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3529],{

/***/ 56006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_best_sellers_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95);
/* harmony import */ var _styles_best_sellers_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_styles_best_sellers_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _product_card_product_card__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91740);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88494);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71911);
/* harmony import */ var _lib_unbxd__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22236);
/* eslint-disable react-hooks/exhaustive-deps */ 









swiper__WEBPACK_IMPORTED_MODULE_6__/* ["default"].use */ .ZP.use([
    swiper__WEBPACK_IMPORTED_MODULE_6__/* .Navigation */ .W_,
    swiper__WEBPACK_IMPORTED_MODULE_6__/* .Pagination */ .tl
]);
var Best_Sellers = function(param) {
    var product = param.product;
    var ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), data = ref1[0], setData = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), title = ref2[0], setTitle = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(product === null || product === void 0 ? void 0 : (ref = product.headers) === null || ref === void 0 ? void 0 : ref["unbxd-request-id"]), requestId = ref3[0], setrequestId = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        loadCustomerFavourite();
    }, []);
    var loadCustomerFavourite = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, products, ref1, payload;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        products = ((ref = product.data.widget3) === null || ref === void 0 ? void 0 : ref.recommendations.filter(function(v) {
                            return !!v.variantId;
                        }).map(function(product) {
                            var ref, ref1, ref2, ref3;
                            return {
                                id: product === null || product === void 0 ? void 0 : product.productId,
                                title: product === null || product === void 0 ? void 0 : product.title,
                                slug: product === null || product === void 0 ? void 0 : product.productUrl.split("/")[(product === null || product === void 0 ? void 0 : product.productUrl.split("/").length) - 1],
                                sku: product === null || product === void 0 ? void 0 : product.uniqueId,
                                try_online: (product === null || product === void 0 ? void 0 : (ref = product.hasTryOnline) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === "true",
                                image: product === null || product === void 0 ? void 0 : product.imageUrl[0],
                                priceId: product.variantId,
                                price: product === null || product === void 0 ? void 0 : product.price,
                                discount: {
                                    total: (product === null || product === void 0 ? void 0 : product.discount) ? product === null || product === void 0 ? void 0 : product.sellingPrice : null,
                                    name: (product === null || product === void 0 ? void 0 : product.discountLabel) || null,
                                    price: (product === null || product === void 0 ? void 0 : product.discount) ? product === null || product === void 0 ? void 0 : product.sellingPrice : null,
                                    text: (product === null || product === void 0 ? void 0 : product.discountLabel) || null
                                },
                                fastDelivery: (product === null || product === void 0 ? void 0 : (ref1 = product.vIsFastDelivery) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === "true",
                                // deal_of_the_day: null,
                                categories: [
                                    {
                                        name: product.categoryPath1[0]
                                    }
                                ],
                                // trending: null,
                                // featured: null,
                                // recomemded: null,
                                best_seller: (product === null || product === void 0 ? void 0 : (ref2 = product.isBestSeller) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) === "true",
                                new_arrival: (product === null || product === void 0 ? void 0 : (ref3 = product.isNewArrival) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) === "true"
                            };
                        })) || [];
                        setData(products);
                        setTitle(product.data.widget3.widgetTitle);
                        if (products.length) {
                            ;
                            payload = {
                                requestId: product === null || product === void 0 ? void 0 : (ref1 = product.headers) === null || ref1 === void 0 ? void 0 : ref1["unbxd-request-id"],
                                pids_list: products.map(function(v) {
                                    return v.sku;
                                }),
                                experience_pagetype: "HOME",
                                experience_widget: "WIDGET3"
                            };
                            (0,_lib_unbxd__WEBPACK_IMPORTED_MODULE_8__/* .unbxdTrackEvent */ .Eg)("experience_impression", payload);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function loadCustomerFavourite() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
        children: !!data.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
            className: (_styles_best_sellers_module_scss__WEBPACK_IMPORTED_MODULE_9___default().best_sellers),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "container-fluid",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: (_styles_best_sellers_module_scss__WEBPACK_IMPORTED_MODULE_9___default().best_sellersheader),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "col-md-12",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: (_styles_best_sellers_module_scss__WEBPACK_IMPORTED_MODULE_9___default().h2),
                                    children: title
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: (_styles_best_sellers_module_scss__WEBPACK_IMPORTED_MODULE_9___default().best_sellers_main),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .Swiper */ .tq, {
                                className: "swiper-navigation-black swiper-custom-arrows",
                                navigation: true,
                                spaceBetween: 20,
                                slidesPerView: 2,
                                loop: true,
                                breakpoints: {
                                    640: {
                                        slidesPerView: 2
                                    },
                                    768: {
                                        slidesPerView: 3
                                    },
                                    1024: {
                                        slidesPerView: 4
                                    },
                                    1200: {
                                        slidesPerView: 5
                                    }
                                },
                                children: data.map(function(product) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .SwiperSlide */ .o5, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_product_card_product_card__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            product: product,
                                            unbxd: {
                                                isunbxd: true,
                                                requestId: requestId,
                                                experience_pagetype: "HOME",
                                                experience_widget: "WIDGET3"
                                            }
                                        })
                                    }, product.id);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "col-md-12",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "text-center pt-0",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        href: "/customers-favourite",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: (_styles_best_sellers_module_scss__WEBPACK_IMPORTED_MODULE_9___default().btn_get_started),
                                            children: [
                                                "SEE ALL Products ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                                    className: "bi bi-arrow-right"
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Best_Sellers);


/***/ }),

/***/ 12026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_trending_design_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14434);
/* harmony import */ var _styles_trending_design_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_trending_design_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88494);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71911);
/* harmony import */ var _product_card_product_card__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91740);
/* harmony import */ var _lib_unbxd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22236);
/* eslint-disable react-hooks/exhaustive-deps */ 








swiper__WEBPACK_IMPORTED_MODULE_4__/* ["default"].use */ .ZP.use([
    swiper__WEBPACK_IMPORTED_MODULE_4__/* .Navigation */ .W_,
    swiper__WEBPACK_IMPORTED_MODULE_4__/* .Pagination */ .tl
]);
var Recommended = function(param) {
    var product = param.product, pagetype = param.pagetype;
    var ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), data = ref1[0], setData = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), title = ref2[0], setTitle = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(product === null || product === void 0 ? void 0 : (ref = product.headers) === null || ref === void 0 ? void 0 : ref["unbxd-request-id"]), requestId = ref3[0], setrequestId = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        recommended();
    }, []);
    var recommended = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, products, payload;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        products = ((ref = product.data.widget1) === null || ref === void 0 ? void 0 : ref.recommendations.filter(function(v) {
                            return !!v.variantId;
                        }).map(function(product) {
                            var ref, ref1, ref2, ref3;
                            return {
                                id: product === null || product === void 0 ? void 0 : product.productId,
                                title: product === null || product === void 0 ? void 0 : product.title,
                                slug: product === null || product === void 0 ? void 0 : product.productUrl.split("/")[(product === null || product === void 0 ? void 0 : product.productUrl.split("/").length) - 1],
                                sku: product === null || product === void 0 ? void 0 : product.uniqueId,
                                try_online: (product === null || product === void 0 ? void 0 : (ref = product.hasTryOnline) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === "true",
                                image: product === null || product === void 0 ? void 0 : product.imageUrl[0],
                                priceId: product.variantId,
                                price: product === null || product === void 0 ? void 0 : product.price,
                                discount: {
                                    total: (product === null || product === void 0 ? void 0 : product.discount) ? product === null || product === void 0 ? void 0 : product.sellingPrice : null,
                                    name: (product === null || product === void 0 ? void 0 : product.discountLabel) || null,
                                    price: (product === null || product === void 0 ? void 0 : product.discount) ? product === null || product === void 0 ? void 0 : product.sellingPrice : null,
                                    text: (product === null || product === void 0 ? void 0 : product.discountLabel) || null
                                },
                                fastDelivery: (product === null || product === void 0 ? void 0 : (ref1 = product.vIsFastDelivery) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === "true",
                                // deal_of_the_day: null,
                                categories: [
                                    {
                                        name: product.categoryPath1[0]
                                    }
                                ],
                                // trending: null,
                                // featured: null,
                                // recomemded: null,
                                best_seller: (product === null || product === void 0 ? void 0 : (ref2 = product.isBestSeller) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) === "true",
                                new_arrival: (product === null || product === void 0 ? void 0 : (ref3 = product.isNewArrival) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) === "true"
                            };
                        })) || [];
                        setData(products);
                        setTitle(product.data.widget1.widgetTitle);
                        if (products.length) {
                            payload = {
                                requestId: requestId,
                                pids_list: products.map(function(v) {
                                    return v.sku;
                                }),
                                experience_pagetype: pagetype,
                                experience_widget: "WIDGET1"
                            };
                            (0,_lib_unbxd__WEBPACK_IMPORTED_MODULE_7__/* .unbxdTrackEvent */ .Eg)("experience_impression", payload);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function recommended() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
        children: !!data.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
            className: (_styles_trending_design_module_scss__WEBPACK_IMPORTED_MODULE_8___default().trending_design),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "container-fluid",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: (_styles_trending_design_module_scss__WEBPACK_IMPORTED_MODULE_8___default().trending_design_header),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "col-md-12",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: (_styles_trending_design_module_scss__WEBPACK_IMPORTED_MODULE_8___default().h2),
                                    children: title
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "row",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "col-md-12",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .Swiper */ .tq, {
                                        className: "swiper-navigation-black swiper-custom-arrows",
                                        navigation: true,
                                        spaceBetween: 20,
                                        slidesPerView: 2,
                                        breakpoints: {
                                            640: {
                                                slidesPerView: 2
                                            },
                                            768: {
                                                slidesPerView: 3
                                            },
                                            1024: {
                                                slidesPerView: 4
                                            },
                                            1200: {
                                                slidesPerView: 5
                                            }
                                        },
                                        children: data.map(function(product) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .SwiperSlide */ .o5, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_product_card_product_card__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                    product: product,
                                                    unbxd: {
                                                        isunbxd: true,
                                                        requestId: requestId,
                                                        experience_pagetype: pagetype,
                                                        experience_widget: "WIDGET1"
                                                    }
                                                })
                                            }, product.id);
                                        })
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Recommended);


/***/ }),

/***/ 75908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_trending_design_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14434);
/* harmony import */ var _styles_trending_design_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_trending_design_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88494);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71911);
/* harmony import */ var _product_card_product_card__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91740);
/* harmony import */ var _lib_unbxd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22236);
/* eslint-disable react-hooks/exhaustive-deps */ 








swiper__WEBPACK_IMPORTED_MODULE_4__/* ["default"].use */ .ZP.use([
    swiper__WEBPACK_IMPORTED_MODULE_4__/* .Navigation */ .W_
]);
var Trending_Design = function(param) {
    var product = param.product, pagetype = param.pagetype;
    var ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), data = ref1[0], setData = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), title = ref2[0], setTitle = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(product === null || product === void 0 ? void 0 : (ref = product.headers) === null || ref === void 0 ? void 0 : ref["unbxd-request-id"]), requestId = ref3[0], setrequestId = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        trendingDesign();
    }, []);
    var trendingDesign = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, products, payload;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        products = ((ref = product.data.widget2) === null || ref === void 0 ? void 0 : ref.recommendations.filter(function(v) {
                            return !!v.variantId;
                        }).map(function(product) {
                            var ref, ref1, ref2, ref3;
                            return {
                                id: product === null || product === void 0 ? void 0 : product.productId,
                                title: product === null || product === void 0 ? void 0 : product.title,
                                slug: product === null || product === void 0 ? void 0 : product.productUrl.split("/")[(product === null || product === void 0 ? void 0 : product.productUrl.split("/").length) - 1],
                                sku: product === null || product === void 0 ? void 0 : product.uniqueId,
                                try_online: (product === null || product === void 0 ? void 0 : (ref = product.hasTryOnline) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === "true",
                                image: product === null || product === void 0 ? void 0 : product.imageUrl[0],
                                priceId: product.variantId,
                                price: product === null || product === void 0 ? void 0 : product.price,
                                discount: {
                                    total: (product === null || product === void 0 ? void 0 : product.discount) ? product === null || product === void 0 ? void 0 : product.sellingPrice : null,
                                    name: (product === null || product === void 0 ? void 0 : product.discountLabel) || null,
                                    price: (product === null || product === void 0 ? void 0 : product.discount) ? product === null || product === void 0 ? void 0 : product.sellingPrice : null,
                                    text: (product === null || product === void 0 ? void 0 : product.discountLabel) || null
                                },
                                fastDelivery: (product === null || product === void 0 ? void 0 : (ref1 = product.vIsFastDelivery) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === "true",
                                // deal_of_the_day: null,
                                categories: [
                                    {
                                        name: product.categoryPath1[0]
                                    }
                                ],
                                // trending: null,
                                // featured: null,
                                // recomemded: null,
                                best_seller: (product === null || product === void 0 ? void 0 : (ref2 = product.isBestSeller) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) === "true",
                                new_arrival: (product === null || product === void 0 ? void 0 : (ref3 = product.isNewArrival) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) === "true"
                            };
                        })) || [];
                        setData(products);
                        setTitle(product.data.widget2.widgetTitle);
                        if (products.length) {
                            payload = {
                                requestId: requestId,
                                pids_list: products.map(function(v) {
                                    return v.sku;
                                }),
                                experience_pagetype: pagetype,
                                experience_widget: "WIDGET2"
                            };
                            (0,_lib_unbxd__WEBPACK_IMPORTED_MODULE_7__/* .unbxdTrackEvent */ .Eg)("experience_impression", payload);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function trendingDesign() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
        children: !!data.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
            className: (_styles_trending_design_module_scss__WEBPACK_IMPORTED_MODULE_8___default().trending_design),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "container-fluid",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: (_styles_trending_design_module_scss__WEBPACK_IMPORTED_MODULE_8___default().trending_design_header),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "col-md-12",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: (_styles_trending_design_module_scss__WEBPACK_IMPORTED_MODULE_8___default().h2),
                                    children: [
                                        title,
                                        " "
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "row",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "col-md-12",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .Swiper */ .tq, {
                                        className: "swiper swiper-custom-arrows",
                                        navigation: true,
                                        spaceBetween: 20,
                                        slidesPerView: 2,
                                        breakpoints: {
                                            640: {
                                                slidesPerView: 2
                                            },
                                            768: {
                                                slidesPerView: 3
                                            },
                                            1024: {
                                                slidesPerView: 4
                                            },
                                            1200: {
                                                slidesPerView: 5
                                            }
                                        },
                                        children: data.map(function(product) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .SwiperSlide */ .o5, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_product_card_product_card__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                    product: product,
                                                    unbxd: {
                                                        isunbxd: true,
                                                        requestId: requestId,
                                                        experience_pagetype: pagetype,
                                                        experience_widget: "WIDGET2"
                                                    }
                                                })
                                            }, product.id);
                                        })
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Trending_Design);


/***/ }),

/***/ 95:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"best_sellers":"best_sellers_best_sellers__d1bN_","best_sellersheader":"best_sellers_best_sellersheader__UxNWU","h2":"best_sellers_h2__jOLyc","best_sellers_main":"best_sellers_best_sellers_main__VgAdo","best_sellers_card":"best_sellers_best_sellers_card__OUO1u","bg_best":"best_sellers_bg_best__MqF5R","best_sellers_wishlist":"best_sellers_best_sellers_wishlist__qGRnk","add_to_card":"best_sellers_add_to_card__s5zin","btn_get_started":"best_sellers_btn_get_started__M8LSw","d_block_hover":"best_sellers_d_block_hover__M1wYX","product_text_d":"best_sellers_product_text_d__7_7Sr","best_ss_p":"best_sellers_best_ss_p__puG80","container":"best_sellers_container__kC_6f"};

/***/ }),

/***/ 14434:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"trending_design":"trending_design_trending_design__htpF_","trending_design_header":"trending_design_trending_design_header__ThAO1","h2":"trending_design_h2__36N4s","trending_design_main":"trending_design_trending_design_main__HchNh","trending_design_card":"trending_design_trending_design_card__F8JQi","trending_design_wishlist":"trending_design_trending_design_wishlist___SqtY","add_to_card":"trending_design_add_to_card___6b4g","btn_get_started":"trending_design_btn_get_started__yuemW"};

/***/ })

}]);